import {
  Box,
  Button,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { loginFormFormSchema } from "./loginFormSchema";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  loginUser,
  clearalerts,
  setSelectedPaymentMethod,
} from "../../../redux-store/auth/auth";
import { backend, backend2 } from "../../../api";
import axios from "axios";
import { ForgotPasswordModal } from ".";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "20px 0",
    margin: "15px 0",
    // backgroundColor: 'black',
    borderRight: `1px solid ${theme.palette.secondary.dark}`,
    [theme.breakpoints.down("md")]: {
      borderBottom: `1px solid ${theme.palette.secondary.dark}`,
      width: "90%",
      margin: "0 auto",
      borderRight: "none",
    },
  },
  form: {
    margin: "20px auto",
    width: "80%",
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "16px",
    fontWeight: 600,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "10px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  heading: {
    fontWeight: 500,
    margin: "5px auto",
    width: "80%",
  },
}));

function LoginForm() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [userType, setUserType] = useState("d2p_user");
  const [passwordModal, setPasswordModal] = useState(false);
  const { currentUser } = useSelector((state) => state.auth);

  const openToast = (message, role) => {
    const options = {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
    };
    if (role === "error") {
      toast.error(message, options);
    } else {
      toast.success(message, options);
    }
  };
  const handleLogin = (values) => {
    dispatch(clearalerts());
    if (userType === "d2p_user") {
      handleD2PLogin(values);
    } else {
      handleEksplodeMemberLogin(values);
    }
  };

  const handleD2PLogin = (values) => {
    backend
      .post("/user/login", values)
      .then((res) => {
        console.log(res?.data);

        const userRole = res?.data?.data?.author?.role; // Get the user's role
        const authorId = res?.data?.data?.author?._id; // Get author ID if available

        if (userRole === "author" && authorId) {
          backend
            .get(`/payment-method?user=${authorId}`)
            .then((res2) => {
              const { paymentMethods } = res2.data;
              dispatch(
                setSelectedPaymentMethod(paymentMethods?.selectedPaymentType)
              );
              toast.success(res.data.message);
            })
            .catch((err) => {
              console.error("Error fetching payment method:", err);
            })
            .finally(() => {
              dispatch(loginUser(res.data));
            });
        } else {
          toast.success(res.data.message);
          dispatch(loginUser(res.data));
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  const handleEksplodeMemberLogin = (values) => {
    axios
      .post(
        "http://ec2-54-234-136-87.compute-1.amazonaws.com/user/login",
        values
      )
      .then((res) => {
        const eksplodeUser = {
          data: res.data.data.user,
          role: "eksplode-member",
          token: res.data.token,
        };
        dispatch(loginUser(eksplodeUser));
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  const handlePasswordModalOpen = () => {
    setPasswordModal(true);
  };
  const handlePasswordModalClose = () => {
    setPasswordModal(false);
  };
  return (
    <div className={classes.root}>
      {userType === "d2p_user" ? (
        <h2 className={classes.heading}>Login as d2p User</h2>
      ) : (
        <h2 className={classes.heading}>Login as Eksplode Member</h2>
      )}
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={(values) => handleLogin(values)}
        validationSchema={loginFormFormSchema}
      >
        {({ errors, touched }) => {
          return (
            <Form className={classes.form}>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Email</InputLabel>
                <Field
                  type="email"
                  name="email"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.email}
                  className={classes.inputField}
                />
                <ErrorMessage name="email">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box mb={2}>
                <InputLabel className={classes.fieldLabel}>Password</InputLabel>
                <Field
                  type="password"
                  name="password"
                  as={OutlinedInput}
                  fullWidth
                  error={errors.password}
                  className={classes.inputField}
                />
                <ErrorMessage name="password">
                  {(error) => (
                    <Typography variant="subtitle2" color="error">
                      {error}
                    </Typography>
                  )}
                </ErrorMessage>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button onClick={handlePasswordModalOpen}>
                  Forgot Password?
                </Button>
                <Button type="submit" className={classes.btn}>
                  Login
                </Button>
              </Box>
              <Box textAlign="center">
                {userType === "d2p_user" ? (
                  <Button
                    color="primary"
                    onClick={() => setUserType("eksplode_member")}
                  >
                    Login as Eksplode Member
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={() => setUserType("d2p_user")}
                  >
                    Login as d2p User
                  </Button>
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
      <ForgotPasswordModal
        visible={passwordModal}
        closeModal={handlePasswordModalClose}
      />
    </div>
  );
}

export default LoginForm;
